import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import api from '~/services/api';

import { successInRequest, failedRequest } from './actions';

export function* requestDlgRelPosto({ payload }) {
    try {
        const { params } = payload;
        const response = yield call(api.get, 'usuarioposto', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });

        const { items, page, pageSize, totalCount, totalPages } = response.data;

        yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export function* applyedFilters({ payload }) {
    try {
        const { params } = payload;

        const response = yield call(api.get, 'usuarioposto', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });

        const { items, page, pageSize, totalCount, totalPages } = response.data;
        yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export default all([
    takeLatest('@dlgrelposto/DLGRELPOSTO_IN_REQUEST', requestDlgRelPosto),
    takeLatest('@dlgrelposto/SUCCESS_REMOVE', requestDlgRelPosto),
    takeLatest('@dlgrelposto/RECORD_FILTERING', applyedFilters),
]);
